import { render, staticRenderFns } from "./serviceArea.vue?vue&type=template&id=235b18ee&scoped=true&"
import script from "./serviceArea.vue?vue&type=script&lang=js&"
export * from "./serviceArea.vue?vue&type=script&lang=js&"
import style0 from "./serviceArea.vue?vue&type=style&index=0&id=235b18ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b18ee",
  null
  
)

export default component.exports